import React, { Component } from 'react';
import { Button, Card, Tabs } from 'antd';
import { StrategyTable } from './StrategyTable';
const TabPane = Tabs.TabPane;
export class OverviewView extends Component {
    render() {
        return (
            <Card
                size="small"
                title={'Strategies'}
                extra={
                    <Button
                        type="primary"
                        onClick={() => this.props.history.push('/a/strategies/standard/new')}
                    >
                        New Strategy
                    </Button>
                }
                bordered={false}
            >
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Buy / Sell" key="1">
                        <StrategyTable type={'buy_sell'} />{' '}
                    </TabPane>
                    <TabPane tab="Automation" key="2">
                        <StrategyTable type={'trigger'} />
                    </TabPane>
                    <TabPane tab="Dollar Cost Averaging" key="3">
                        <StrategyTable type={'adca'} />
                    </TabPane>
                    <TabPane tab="Reverse Trading" key="4">
                        <StrategyTable type={'art'} />
                    </TabPane>
                    <TabPane tab="Signal" key="5">
                        <StrategyTable type={'signal'} />
                    </TabPane>
                </Tabs>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Overview/index.js